import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="besitzer"
export default class extends Controller {
	static targets = ["person", "prozentInput"]
	connect() {}

	// Update der Person bei Vermögenselementen, die nur einen Besitzer haben können
	updatePerson() {
		const personen = this.personTargets
		if (personen.length < 2) return // Wenn es keinen Partner gibt, passiert nichts

		const gewaehltePerson = personen.find((el) => el.classList.contains("hidden"))
		const inputPersonId = this.element.querySelector(".person_id_input")
		const inputPersonType = this.element.querySelector(".person_type_input")

		personen.forEach((person) => person.classList.toggle("hidden"))

		inputPersonId.value = gewaehltePerson.dataset.personid
		inputPersonType.value = gewaehltePerson.dataset.persontype
	}

	// Update der Personenanteile bei Vermögenselementen, die nur mehrere Besitzer haben können
	updateAnteile({ currentTarget }) {
		// Besitzer der bearbeitet wurde
		const aktuellerBesitzer = currentTarget.closest('[data-besitzer-target="person"]')
		const prozent = currentTarget.value
		aktuellerBesitzer.querySelector(".remove_field").value = prozent > 0 ? 0 : 1

		// Anderer Besitzer
		const andererProzentInput = this.prozentInputTargets.find((el) => el !== currentTarget)
		if (andererProzentInput == null) return
		const andererBesitzer = andererProzentInput.closest('[data-besitzer-target="person"]')
		const prozent_anderer = 100 - prozent
		andererProzentInput.value = prozent_anderer
		andererBesitzer.querySelector(".remove_field").value = prozent_anderer > 0 ? 0 : 1
	}
}
